
import React from 'react'
import ActionText from 'ui/ActionText'
import css from './ResetFooter.module.css'

const ResetFooter = () => (
  <footer className={css.main}>
    <ActionText
      text='Already have an account?'
      linkHref='/login'
      linkText='Log in' />

    <ActionText
      text='Don’t have an account?'
      linkHref='/signup'
      linkText='Sign up' />
  </footer>
)

export default ResetFooter



// WEBPACK FOOTER //
// ./components/ResetFooter.js